import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import Router from "./components/Router";
import { extractHigherRole } from "./features/auth/authHelpers";
import { userLoaded, userUnloaded } from "./features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "./features/redux-store/hooks";
import { themePrimary } from "./utils/themes";
import ThemeProvider from "./components/ThemeProvider";
import LoadingView from "./components/ui/LoadingView/LoadingView";
import { useRole } from "./features/roles/useRole";
// const env = process.env.REACT_APP_ENV;

const App: React.FC = () => {
  const dispatch = useAppDispatch();

  const rehydrated = useAppSelector((state) => state._persist.rehydrated);

  const auth = useAuth();
  const { isAuthenticated } = auth;
  const { isAdmin, isPilote, isPerformer } = useRole();

  /**
   * "addUserLoaded" effect
   * Triggered by the OpenID Connect library when a connection
   * is established (login) or re-established (refreshToken)
   */
  useEffect(() => {
    return auth.events.addUserLoaded((_user) => {
      const role = extractHigherRole(_user.access_token);
      console.log("ð User loaded", _user, `role: ${role}`);
      dispatch(userLoaded({ user: _user, role }));
    });
  }, [auth.events, dispatch]);

  useEffect(() => {
    return auth.events.addUserUnloaded(() => {
      // const role = getRole(_user.access_token);
      console.log("ð User signout");
      dispatch(userUnloaded());
    });
  }, [auth.events, dispatch]);

  // Wait for the rehydration (redux-persist) to complete before rendering the app
  if (!rehydrated) {
    return null;
  }

  // Handle the silent signin/signout (TODO: keep it ?)
  switch (auth.activeNavigator) {
    case "signinSilent":
      return <LoadingView message="Connexion en cours" />;
    case "signoutRedirect":
      return <LoadingView message="DÃ©connexion" />;
  }

  // return <LoadingView message="Chargement" />;

  if (auth.isLoading) {
    return <LoadingView message="Chargement" />;
  }

  // Handle the auth error (TODO: improve it ?)
  if (auth.error) {
    if (location.href.includes("?")) {
      history.pushState({}, "", location.href.split("?")[0]);
    }
    return (
      <LoadingView
        message={`Une erreur est survenue: ${auth.error?.message}`}
        hideLoader
      />
    );
  }

  return (
    <ThemeProvider theme={themePrimary}>
      <Router
        isAuthenticated={isAuthenticated}
        isAdmin={isAdmin}
        isPilote={isPilote}
        isPerformer={isPerformer}
      />
    </ThemeProvider>
  );
};

export default App;
